/* eslint-disable no-console */
import { EntityService } from 'utils/entityService';
import { wait } from 'utils/wait';

export function Mock<T extends EntityService>(
  mockData: (...args: any[]) => unknown,
  responseDelay = 500
) {
  return (_target: T, propertyKey: string, descriptor: PropertyDescriptor) => {
    if (import.meta.env.MODE === 'mock') {
      const originalName = _target?.constructor?.name;
      const calledMethod = [originalName, propertyKey].join('.');

      descriptor.value = async (...args: unknown[]) => {
        const mock = await mockData(...args);
        const result = await wait({ data: mock, ms: responseDelay });

        console.group(`[API] ${calledMethod}`);
        console.log('args', args);
        console.log('result', result);
        console.groupEnd();

        return result;
      };
    }
  };
}
